import React from "react";
import Table from "../../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import LeaveWoPayPresenter from "./LeaveWoPayPresenter";
import Progress from "../../../../../../components/Progress";

class LeaveWoPayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveWoPayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "leave_request";
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    const excludeFieldsFather = [
      "selectedType",
      "halfDay",
      "startdate",
      "enddate",
      "createdAt",
      "duration",
      "stats",
      "categoryType",
    ];
    const applyField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key)
    );

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                // objectData={this.handleViewData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                // actionsList={[
                //   {
                //     label: <i className="bi bi-search"> View</i>,
                //     actionType: "object",
                //   },
                // ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, applyField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default LeaveWoPayPage;
